/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\SeenCar\SeenCarModule\SeenCarModule.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Thursday December 21st 2023
 * Author: Jonathan MAZAT
 * -----
 * Last Modified: Thursday December 21st 2023 5:37:36 pm
 * Modified By: the developer formerly known as Jonathan MAZAT at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import translator from "MultiLanguage/TranslationWrapper";
import { SeenCarType } from "../SeenCarRow/SeenCarRow";
import SeenCarTableMemo from "../SeenCarTable/SeenCarTable";
import { Button } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useIntersectionObserver } from "react-intersection-observer-hook";
import SeenCarService from "Services/SeenCar/SeenCar.service";
import TimeFilter from "Content/TimeFilter/TimeFilter";
import Styles from "Content/SeenCar/SeenCarModule/SeenCarModule.module.css";

type SeenCarModuleProps = {
    showTimeFilter: boolean
    myViews: SeenCarType[],
    viewCount: number,
    userID?: string,
    sellID?: string,
    order?: string,
    orderby?: string,
    setOrderBy?: Function,
    setOrder?: Function,
}

function SeenCarModule (props: SeenCarModuleProps) {
    const [page, setPage] = useState(0);
    const [myViews, setMyViews] = useState<SeenCarType[]>(props.myViews);
    const [myCount, setMyCount] = useState<number>(props.viewCount);
    const timeFilter = useRef<{curActive: string, curOrder: string} | null>();
    const [ref, { entry }] = useIntersectionObserver();
    const isVisible = entry && entry.isIntersecting;

    useEffect(() => {
        setMyViews(props.myViews);
        setMyCount(props.viewCount);
    }, [props.myViews]);

    useEffect(() => {
        if (isVisible)
            handleLoadMoreViews();
    }, [isVisible]);

    function handleUpdateFilter(filters: {from: string, order: string}) {
        const url = window.location;
        // setMyConnexion([]);
        SeenCarService.getAllView({...filters, userid: props.userID, sellid: props.sellID}).then((res: {count: number, seenCar: SeenCarType[]}) => {
            const searchParams = new URLSearchParams(url.search);
            searchParams.set("page", "1");
            searchParams.set("order", filters.order);
            searchParams.set("orderby", filters.from);
            window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
            setMyViews(res.seenCar);
            setMyCount(res.count);
            if (page === 0)
                setPage(-1);
            else
                setPage(0);
        }).catch((error) => {
            console.error(error);
        });
    };

    function handleLoadMoreViews() {
        const url = window.location;
        const myParams = {
            page: 1,
            order: timeFilter?.current?.curOrder,
            from: timeFilter?.current?.curActive,
            userid: props.userID,
            sellid: props.sellID
        };
        const searchParams = new URLSearchParams(url.search);
        if (searchParams.has("page"))
            myParams.page = parseInt(searchParams.get('page')!);
        myParams.page = myParams.page + 1;
        SeenCarService.getAllView(myParams).then((res: {count: number, seenCar: SeenCarType[]}) => {
            const searchParams = new URLSearchParams(url.search);
            searchParams.set("page", myParams.page.toString());
            window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
            setPage(myParams.page);
            setMyCount(res.count);
            setMyViews([...myViews, ...res.seenCar]);
        })
        .catch((error: any) => {
            console.error(error);
        });
    };

    return (
        <>
            <div className={`${Styles.holderTopBar}`} >
                <p className="m-0">{translator.decode("dynamic.total")}: {myCount}</p>
                {
                    props.showTimeFilter ?
                    <TimeFilter ref={timeFilter} handleUpdateFilter={handleUpdateFilter} order={props.order} orderBy={props.orderby} setOrderBy={props.setOrderBy} setOrder={props.setOrder} />
                    :null
                }
            </div>
            <SeenCarTableMemo displayName={false} seenCar={myViews} order={props.order ?? timeFilter?.current?.curOrder} />
            {
                myCount > 0 && myViews.length > 0 && myViews.length !== myCount ?
                <Button ref={ref} className="p-2" onClick={handleLoadMoreViews}>{translator.decode("dynamic.more")}</Button>
                :null
            }
        </>
    )
}

export default SeenCarModule;
